import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, Check } from 'lucide-react';
import api from '../api/client';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email.trim()) {
      return setError('E-posta gerekli');
    }

    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Bir hata oluştu, lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-extrabold" style={{ letterSpacing: '-1px' }}>
            <span className="text-white">field</span>
            <span className="text-blue-500">pin</span>
          </h1>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-8">
          {submitted ? (
            <>
              <div className="flex justify-center mb-4">
                <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
                  <Check size={24} className="text-green-600" />
                </div>
              </div>
              <h2 className="text-lg font-semibold text-slate-800 mb-2 text-center">
                E-posta Gönderildi
              </h2>
              <p className="text-sm text-slate-500 text-center leading-relaxed mb-6">
                E-posta adresiniz kayıtlıysa, şifre sıfırlama bağlantısı gönderilecektir. Lütfen e-postanızı kontrol edin (spam klasörünü de).
              </p>
              <Link
                to="/login"
                className="flex items-center justify-center gap-2 w-full py-3 bg-slate-800 text-white font-semibold rounded-xl hover:bg-slate-900 transition"
              >
                <ArrowLeft size={16} /> Giriş Sayfasına Dön
              </Link>
            </>
          ) : (
            <>
              <h2 className="text-lg font-semibold text-slate-800 mb-1">Şifremi Unuttum</h2>
              <p className="text-sm text-slate-500 mb-6">
                Hesabınıza ait e-posta adresini girin. Size şifre sıfırlama bağlantısı göndereceğiz.
              </p>

              {error && (
                <div className="bg-red-50 border border-red-200 text-red-600 text-sm px-4 py-3 rounded-lg mb-4">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-slate-700 mb-1.5 block">
                    E-posta
                  </label>
                  <div className="relative">
                    <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="ornek@firmaniz.com"
                      className="w-full pl-10 pr-4 py-2.5 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                      required
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 disabled:opacity-50 transition"
                >
                  {loading ? 'Gönderiliyor...' : 'Sıfırlama Bağlantısı Gönder'}
                </button>
              </form>

              <Link
                to="/login"
                className="flex items-center justify-center gap-1.5 text-sm text-slate-500 hover:text-slate-700 mt-5"
              >
                <ArrowLeft size={14} /> Giriş sayfasına dön
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
